import React from "react";

function DetailsIcon({ fill = "white", height = "24", width = "24" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.61538 1C9.0827 1 9.46154 1.37884 9.46154 1.84615V2.18365C10.3489 2.14963 11.2181 2.12821 12 2.12821C12.7819 2.12821 13.6511 2.14963 14.5385 2.18365V1.84615C14.5385 1.37884 14.9173 1 15.3846 1C15.8519 1 16.2308 1.37884 16.2308 1.84615V2.26129C17.561 2.33127 18.8331 2.41713 19.8105 2.48864C21.3114 2.59846 22.5042 3.77908 22.6264 5.28031C22.7836 7.21121 23 10.2795 23 12.5641C23 14.8487 22.7836 17.917 22.6264 19.8479C22.5042 21.3491 21.3114 22.5297 19.8105 22.6396C17.7732 22.7886 14.4559 23 12 23C9.54406 23 6.22675 22.7886 4.18948 22.6396C2.68858 22.5297 1.49582 21.3491 1.37361 19.8479C1.21642 17.917 1 14.8487 1 12.5641C1 10.2795 1.21642 7.21121 1.37361 5.28031C1.49582 3.77908 2.68858 2.59846 4.18948 2.48864C5.16691 2.41713 6.439 2.33127 7.76923 2.26129V1.84615C7.76923 1.37884 8.14807 1 8.61538 1ZM7.48678 10.0259C7.01946 10.0259 6.64062 10.4047 6.64062 10.872C6.64062 11.3394 7.01946 11.7182 7.48678 11.7182H16.5124C16.9797 11.7182 17.3586 11.3394 17.3586 10.872C17.3586 10.4047 16.9797 10.0259 16.5124 10.0259H7.48678ZM7.48678 14.5387C7.01946 14.5387 6.64062 14.9175 6.64062 15.3849C6.64062 15.8522 7.01946 16.231 7.48678 16.231H11.9996C12.4669 16.231 12.8458 15.8522 12.8458 15.3849C12.8458 14.9175 12.4669 14.5387 11.9996 14.5387H7.48678Z"
        fill={fill}
      />
    </svg>
  );
}

export default DetailsIcon;
